// import clsx from 'clsx';
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { responsiveCssProperties, useResponsiveProp } from '../../utils';
import { parseFlexValue } from './BoxUtils';
export const BoxRestricted = forwardRef(function BoxRestricted(props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { children, elementType = 'div', className, style, alignSelf, aspectRatio, justifySelf, flex, flexBasis, flexGrow, flexShrink, order, gridArea, gridColumn, gridColumnStart, gridColumnEnd, gridRow, gridRowStart, gridRowEnd, margin, marginBlock, marginBlockStart, marginBlockEnd, marginInline, marginInlineStart, marginInlineEnd, width, maxWidth, minWidth, height, maxHeight, minHeight, position, inset, insetBlock, insetBlockStart, insetBlockEnd, insetInline, insetInlineStart, insetInlineEnd, verticalAlign, zIndex, hidden, UNSAFE_hideWhenEmpty, ...rest } = getCalculatedProps(props);
    const Element = elementType;
    const responsiveHidden = useResponsiveProp(hidden);
    const { flexGrow: calculatedFlexGrow, flexShrink: calculatedFlexShrink, flexBasis: calculatedFlexBasis, } = parseFlexValue(useResponsiveProp(flex));
    if (responsiveHidden) {
        return null;
    }
    return (React.createElement(Element, { ...rest, className: clsx('mollie-ui-box', { 'mollie-ui-box--hide-when-empty': UNSAFE_hideWhenEmpty }, className), style: {
            ...style,
            ...responsiveCssProperties({
                '--mollie-ui-box-align-self': alignSelf,
                '--mollie-ui-box-aspect-ratio': aspectRatio,
                '--mollie-ui-box-justify-self': justifySelf,
                '--mollie-ui-box-flex-basis': flexBasis !== null && flexBasis !== void 0 ? flexBasis : calculatedFlexBasis,
                '--mollie-ui-box-flex-grow': flexGrow !== null && flexGrow !== void 0 ? flexGrow : calculatedFlexGrow,
                '--mollie-ui-box-flex-shrink': flexShrink !== null && flexShrink !== void 0 ? flexShrink : calculatedFlexShrink,
                '--mollie-ui-box-order': order,
                '--mollie-ui-box-grid-area': gridArea,
                '--mollie-ui-box-grid-column-start': gridColumnStart,
                '--mollie-ui-box-grid-column-end': gridColumnEnd,
                '--mollie-ui-box-grid-row-start': gridRowStart,
                '--mollie-ui-box-grid-row-end': gridRowEnd,
                '--mollie-ui-box-margin-block-start': (_a = marginBlockStart !== null && marginBlockStart !== void 0 ? marginBlockStart : marginBlock) !== null && _a !== void 0 ? _a : margin,
                '--mollie-ui-box-margin-block-end': (_b = marginBlockEnd !== null && marginBlockEnd !== void 0 ? marginBlockEnd : marginBlock) !== null && _b !== void 0 ? _b : margin,
                '--mollie-ui-box-margin-inline-start': (_c = marginInlineStart !== null && marginInlineStart !== void 0 ? marginInlineStart : marginInline) !== null && _c !== void 0 ? _c : margin,
                '--mollie-ui-box-margin-inline-end': (_d = marginInlineEnd !== null && marginInlineEnd !== void 0 ? marginInlineEnd : marginInline) !== null && _d !== void 0 ? _d : margin,
                '--mollie-ui-box-width': width,
                '--mollie-ui-box-max-width': maxWidth,
                '--mollie-ui-box-min-width': minWidth,
                '--mollie-ui-box-height': height,
                '--mollie-ui-box-max-height': maxHeight,
                '--mollie-ui-box-min-height': minHeight,
                '--mollie-ui-box-position': position,
                '--mollie-ui-box-inset-block-start': (_e = insetBlockStart !== null && insetBlockStart !== void 0 ? insetBlockStart : insetBlock) !== null && _e !== void 0 ? _e : inset,
                '--mollie-ui-box-inset-block-end': (_f = insetBlockEnd !== null && insetBlockEnd !== void 0 ? insetBlockEnd : insetBlock) !== null && _f !== void 0 ? _f : inset,
                '--mollie-ui-box-inset-inline-start': (_g = insetInlineStart !== null && insetInlineStart !== void 0 ? insetInlineStart : insetInline) !== null && _g !== void 0 ? _g : inset,
                '--mollie-ui-box-inset-inline-end': (_h = insetInlineEnd !== null && insetInlineEnd !== void 0 ? insetInlineEnd : insetInline) !== null && _h !== void 0 ? _h : inset,
                '--mollie-ui-box-vertical-align': verticalAlign,
                '--mollie-ui-box-z-index': zIndex,
            }),
        }, ref: ref }, children));
});
BoxRestricted.displayName = 'Box.Restricted';
function getCalculatedProps(props) {
    let { gridColumnStart, gridColumnEnd, gridRowStart, gridRowEnd } = props;
    const { gridColumn, gridRow } = props;
    if (!gridColumnStart && gridColumn) {
        gridColumnStart = getGridValue(gridColumn, 'start');
    }
    if (!gridColumnEnd && gridColumn) {
        gridColumnEnd = getGridValue(gridColumn, 'end');
    }
    if (!gridRowStart && gridRow) {
        gridRowStart = getGridValue(gridRow, 'start');
    }
    if (!gridRowEnd && gridRow) {
        gridRowEnd = getGridValue(gridRow, 'end');
    }
    return {
        ...props,
        gridColumnStart,
        gridColumnEnd,
        gridRowStart,
        gridRowEnd,
    };
}
function getGridValue(value, position) {
    var _a;
    if (value == null) {
        return '';
    }
    if (typeof value === 'string') {
        const matches = ((_a = value.match(/(?<start>(span )?[\w\-\d]+)(\s+?\/\s+?)?(?<end>(span )?[\w\-\d]+)?/)) === null || _a === void 0 ? void 0 : _a.groups) || {};
        return matches[position] || matches['start'];
    }
    return Object.keys(value).reduce((responsive, breakpoint) => {
        responsive[breakpoint] = getGridValue(value[breakpoint], position);
        return responsive;
    }, {});
}
//# sourceMappingURL=BoxRestricted.js.map